import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { cx, keyframes, makeStyles } from "../util/tss-react/index.js";
const useStyles = makeStyles()({
    dots: {
        '&::after': {
            display: 'inline-block',
            content: '""',
            width: '1em',
            textAlign: 'left',
            animation: `${keyframes `
      0% {
        content: '';
      }
      25% {
          content: '.';
      }
      50% {
        content: '..';
      }
      75% {
        content: '...';
      }
      `} 1.2s infinite ease-in-out`,
        },
    },
});
export default function LoadingEllipses({ message, children, variant = 'body2', ...rest }) {
    const { classes } = useStyles();
    return (_jsx(Typography, { className: cx(classes.dots, rest.className), ...rest, variant: variant, children: message || 'Loading' }));
}
